import OSSAgreement from '../OSSAgreement'

export const MODALS = {
  ossTerms: OSSAgreement
}
